export function setMensajes(state, mensajes) {
    state.mensajes = mensajes;
    
}

export function setMensajeSelec(state, mensaje) {
    state.mensajeSelec = mensaje;
}

export function actListMensajes(state, mensaje) {
    if (mensaje !== null) {
        const index = state.mensajes.findIndex(r => r.id === mensaje.id)
        if (index != -1) {
            state.mensajes[index].titulo = mensaje.titulo;  
            state.mensajes[index].texto = mensaje.texto;  
            state.mensajes[index].asunto = mensaje.asunto;  
           
        }
    }
  
}

export function actDeleteListMensajes(state, id) {
    if (id != null) {
        const index = state.mensajes.findIndex(r => r.id === id)
        if (index != -1) {
            state.mensajes.splice(index, 1)
        }
    }
}

